import { render, staticRenderFns } from "./dialog-adminpolicy.vue?vue&type=template&id=2417a0cd&"
import script from "./dialog-adminpolicy.vue?vue&type=script&lang=js&"
export * from "./dialog-adminpolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports